/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_Cloud_IconInputs */

const en_enum_custom_page_icon_cloud_icon = /** @type {(inputs: Enum_Custom_Page_Icon_Cloud_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icon Cloud Icon`)
};

const de_enum_custom_page_icon_cloud_icon = /** @type {(inputs: Enum_Custom_Page_Icon_Cloud_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icon Cloud Icon`)
};

/**
* | output |
* | --- |
* | "Icon Cloud Icon" |
*
* @param {Enum_Custom_Page_Icon_Cloud_IconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_cloud_icon = /** @type {((inputs?: Enum_Custom_Page_Icon_Cloud_IconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_Cloud_IconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_cloud_icon(inputs)
	return de_enum_custom_page_icon_cloud_icon(inputs)
});